module.exports = __webpack_public_path__ + "img/xueyuan.6b2cac44.png";